import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
    AppBar,
    Toolbar,
    Typography,
    Grid,
    IconButton,
    Drawer,
    List,
    ListItemIcon,
    Divider,
    ListItemText,
    ListItemButton,
} from '@mui/material'

import { Menu, Apple, Android } from '@mui/icons-material'

import './NavBar.css'

const NavBar = () => {
    const { t } = useTranslation()
    const [drawerOpen, setDrawerOpen] = useState(false)

    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen)
    }

    function onDownloadIOSAppClicked() {
        //새 창에서 열기
        window.open('https://apps.apple.com/app/id1640411795', '_blank')
        //현재 창에서 열기
        //window.location.href = 'https://apps.apple.com/app/id1640411795'
    }

    function onDownloadAndroidAppClicked() {
        window.open(
            'https://play.google.com/store/apps/details?id=com.tino.mn',
            '_blank'
        )
    }

    const menuItems = [
        {
            name: t('download_ios_app'),
            icon: <Apple />,
            onClick: onDownloadIOSAppClicked,
        },
        {
            name: t('download_android_app'),
            icon: <Android />,
            onClick: onDownloadAndroidAppClicked,
        },
    ]

    const drawer = (
        <div>
            <Toolbar />
            <Divider />
            <List>
                {menuItems.map((item, index) => (
                    <ListItemButton key={index} onClick={item.onClick}>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText primary={item.name} />
                    </ListItemButton>
                ))}
            </List>
            <Divider />
        </div>
    )

    return (
        <>
            <AppBar
                position="sticky"
                style={{ background: '#333333', height: '60px' }}
            >
                <Toolbar>
                    <IconButton
                        id="Menu"
                        color="inherit"
                        onClick={handleDrawerToggle}
                    >
                        <Menu />
                    </IconButton>
                    <Grid container>
                        <Grid item container xs={8} alignItems="center">
                            <NavLink
                                style={({
                                    isActive,
                                    isPending,
                                    isTransitioning,
                                }) => {
                                    return {
                                        color: 'white',
                                        textDecoration: 'none',
                                    }
                                }}
                                to={'/'}
                            >
                                <Typography
                                    variant="h5"
                                    className="NavBar-navigation-logo"
                                >
                                    nunnu
                                </Typography>
                            </NavLink>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>

            <Drawer
                variant="temporary"
                open={drawerOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
            >
                {drawer}
            </Drawer>
        </>
    )
}

export default NavBar
